// Carrega os dados do emoji-mart e enriquece as palavras-chave de cada emoji
// com os termos em português (nome + tags) do emojibase-data, para que a busca
// funcione em pt-br além de inglês. Tudo é importado sob demanda para não pesar
// o bundle da página; a mesclagem é idempotente (deduplica ao repetir).

// Remove o seletor de variação (U+FE0F) para casar o emoji nativo entre datasets.
const stripVariation = value => (value || '').replace(/️/g, '');

// Remove acentos para permitir busca com ou sem acento (ex.: "coracao" acha "coração").
const stripDiacritics = value => value.normalize('NFD').replace(/[̀-ͯ]/g, '');

let mergedDataPromise = null;

export const loadEmojiPickerData = () => {
    if (mergedDataPromise) return mergedDataPromise;

    mergedDataPromise = Promise.all([
        import('@emoji-mart/data'),
        import('emojibase-data/pt/data.json')
    ]).then(([emojiMartModule, ptModule]) => {
        const data = emojiMartModule.default;
        const ptEmojis = ptModule.default;

        const ptTermsByNative = {};
        ptEmojis.forEach(item => {
            ptTermsByNative[stripVariation(item.emoji)] = [item.label, ...(item.tags || [])];
        });

        Object.values(data.emojis).forEach(emoji => {
            const native = emoji.skins?.[0]?.native;
            const ptTerms = ptTermsByNative[stripVariation(native)];
            if (!ptTerms) return;

            const existing = new Set((emoji.keywords || []).map(keyword => keyword.toLowerCase()));
            const addTerm = term => {
                if (term && !existing.has(term)) {
                    emoji.keywords.push(term);
                    existing.add(term);
                }
            };

            ptTerms.forEach(term => {
                const normalized = term.toLowerCase();
                addTerm(normalized);
                addTerm(stripDiacritics(normalized));
            });
        });

        return data;
    }).catch(error => {
        // Não travar o seletor caso o dataset pt falhe: permite nova tentativa.
        mergedDataPromise = null;
        throw error;
    });

    return mergedDataPromise;
};
